<template>
  <div class="draft">
    <div
      v-for="(item, index) in list"
      @click="select(index)"
      :key="index"
      class="list-cell"
    >
      <div class="msg">
        <div class="flex-row">
          <div class="title">{{ item.type != 'record' ? '快速记草稿' : '观察记录表草稿' }}</div>
          <a-space>
            <a-button size="small" shape="round" @click="handleEditDraft(index)">编辑</a-button>
            <a-button size="small" shape="round" @click="handleDelDraft(index)" type="danger">删除</a-button>
          </a-space>
        </div>
        
        <div class="content">
          观察对象：{{ item.students.map(item=>item.name).join("、") }}
        </div>
        <div class="time">记录与{{ item.data.record_time }}</div>
      </div>
    </div>
    <a-spin v-if="loading" :spining="loading" style="height: 200px;width: 100%;"></a-spin>
    <a-empty v-else-if="list.length == 0" description="暂无草稿"></a-empty>
  </div>
</template>

<script>
import axios from 'axios';
import { leaderApi as directorTestApi } from '../../api/api-director';
import qs from 'qs'
import { mapState } from 'vuex';

export default {
  data() {
    return {
      selectIndex: 0,
      showModal: false,
      currentObserve: null,
    };
  },
  props:{
    list: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed:{
    ...mapState(['userInfo'])
  },
  watch: {
      showModal() {
        if (!this.showModal) {
            this.$emit("close");
        }
      }
  },
  methods: {
    select(index) {
      this.selectIndex = index;
      this.currentObserve = this.list[index];
      this.showModal = true;
    },
    handleDelDraft(index) {
      this.$confirm({
        title: "提示",
        content: "确定删除吗？",
        okText: "确定",
        centered: true,
        cancelText: "取消",
        onOk: () => {
          axios({
            url: directorTestApi.main + directorTestApi.delObserAll,
            method: "POST",
            data: qs.stringify({
              id: this.list[index].id,
              leader_id: this.userInfo.id
            })
          }).then((res) => {
            if (res.data.result) {
              this.list.splice(index, 1)
              this.showModal = false
              this.selectIndex = -1
              this.currentObserve = null
              this.$emit('del')
              this.$message.success("删除成功");
            } else{
              this.$message.error(res.data.message);
            }
          })
        },
        onCancel:() => {
          this.showModal = false
        },
      });
    },
    handleEditDraft(index) {
      this.$router.push({
        path: '/observe/add',
        query:{
          id: this.list[index].id,
          type: this.list[index].type
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>

.draft {
  width: 100%;
  padding: 15px;
  .title {
    font-size: 14px;
    color: #101010;
    font-weight: bold;
  }

  .list-cell {
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;
  }
}

.split {
  height: 10px;
  background: #f1f1f1;
}

.drawer-content {
  .head {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    padding: 15px;
    .title {
      flex: 1;
      text-align: left;
      margin-left: 2px;
      font-size: 16px;
      font-family: "微软雅黑";
      font-weight: bold;
      //字体平滑
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }

  .content {
    padding: 0;
    margin-top: 6px;
  }

  .time{
    color: #999;
    font-size: 12px;
  }

}
.list {
  padding: 0 15px;
}
.list-cell {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  margin: 10px 0 30px 0;
  cursor: pointer;
  .avatar {
    width: 36px;
    height: 36px;
    margin-right: 10px;
  }
  .msg {
    flex: 1;
    display: flex;
    flex-direction: column;
    .header {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 14px;
      color: #101010;
      .teacher {
        font-weight: bold;
        font-size: 14px;
      }

      .students {
        font-weight: bold;
      }

      .action {
        margin: 0 6px;
      }

      .info {
        margin-left: 10px;
      }

      .time {
        margin: 0 10px;
      }

      .status {
        color: #519fd3;
      }
    }

    .content {
      margin-top: 6px;
      color: #6a6a6a;
    }
  }
}


</style>
